/* eslint-disable no-shadow */
/* eslint-disable init-declarations */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Grid, Typography } from '@mui/material';
import {
  StyledTabs,
  StyledTab,
  StyledInput,
  NextButton,
  TicketButton,
} from 'components/Common/MUIStyledComponents';
import { Redirect } from 'react-router-dom';
import { GlobalContext } from 'providers/GlobalProvider';
import React, { useState, useRef, useEffect, useContext } from 'react';
import DatahubAPI from 'api/DatahubAPI';
import { useSnackbar } from 'notistack';
import { searchReport } from 'components/Common/PDFKitManage';
import { Prompt } from 'react-router-dom';
import { Player } from '@lottiefiles/react-lottie-player';
import EntityForm from 'components/BiteScore/EntityForm';
import CommodityForm from 'components/BiteScore/CommodityForm';
import ScoreIndicator from 'components/BiteBulk/ScoreIndicator';
import Table from 'components/BiteScore/Table';
import Modal from 'react-modal';
import TabPanel from 'components/Common/TabPanel';
import CasesAPI from 'api/CasesAPI';
import { format } from 'date-fns';
import { toBase64, downloadBase64Data } from 'utils/fileHelper';
import ModuleHeaderLayout from 'components/Common/Layouts/ModuleHeaderLayout';

const BiteScore: React.FC = () => {
  const refForPdf = useRef<any>(null);

  type Hit = {
    field: any;
    module: string;
    dataSet: string;
    name: string;
    doc: any;
  };

  // PAYMENTS STATE AND FUNCTIONS
  const { cur_user } = useContext(GlobalContext);
  const [userHasBiteScore, setUserHasBiteScore] = useState(false);

  if (!cur_user.selected_team) {
    return <Redirect to='/' />;
  }

  const checkForBiteScoreAndTrial = () => {
    if (cur_user.selected_team?.attributes?.tier?.includes('enterprise')) {
      setUserHasBiteScore(true);
    }
  };

  useEffect(() => {
    checkForBiteScoreAndTrial();
  }, []);

  // PAGE STATE AND STATE CHANGING FUNCTIONS
  const [commodityScore, setCommodityScore] = useState(0);
  const [entityScore, setEntityScore] = useState(0);
  const [entityHits, setEntityHits] = useState<Hit[]>([]);
  const [commodityHits, setCommodityHits] = useState<Hit[]>([]);
  const [fileNameModalOpen, setFileNameModalOpen] = useState(false);
  const [fileName, setFileName] = useState('');
  const [pdfQuery, setPDFQuery] = useState({});
  const [tabValue, setTabValue] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [pageNum, setPageNum] = useState(0);
  const [entityPages, setEntityPages] = useState(0);
  const [optsState, setOptsState] = useState({
    ticket: false,
    fuzzy: false,
  });
  const [vals, setVals] = useState({});

  const dt = new Date();
  const dtWithoutTz = new Date(
    dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000,
  );
  const formatted_dt = format(dtWithoutTz, 'yyyy-MM-dd');

  const handleFileNameChange = (e: any) => {
    setFileName(e.target.value);
  };
  const handleFileNameClose = () => {
    setFileNameModalOpen(false);
    setFileName('');
  };

  const { enqueueSnackbar } = useSnackbar();

  const resetPage = () => {
    setEntityScore(0);
    setCommodityScore(0);
    setEntityHits([]);
    setCommodityHits([]);
    setPDFQuery({});
    setOptsState({
      ticket: false,
      fuzzy: false,
    });
    setVals({});
    setPageNum(0);
  };

  // MANAGE TOP LEVEL TABS
  const tabChange = (e: any, newValue: number) => {
    setTabValue(newValue);
    setPageNum(0);
  };

  const a11yProps = (index: number) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  };

  // PDF DOWNLOADING
  const headers = ['Field', 'Module', 'Dataset', 'Name'];
  const handleDownloadPDF = () => {
    if (Object.keys(pdfQuery).length >= 1) {
      searchReport(
        fileName,
        refForPdf,
        pdfQuery,
        headers,
        [...entityHits, ...commodityHits],
        true,
        'bite-score',
      );
    } else {
      enqueueSnackbar('No Search has Run to Download Results', {
        variant: 'error',
      });
    }
  };

  // CHANGING PAGES
  const handlePageChange = (e: any, new_page: number) => {
    setPageNum(new_page);
    handleSubmit(vals, new_page);
  };

  // MAIN SUBMIT FUNCTION AND API CALL
  const handleSubmit = async (values: any, page: number) => {
    setVals(values);
    let pageNumber = 0;
    if (page > 0) {
      pageNumber = page - 1;
    }
    const fuzzyNum = optsState.fuzzy === false ? '0' : 'AUTO';

    setIsLoading(true);

    // Rules for required fields
    if (Object.keys(values).length < 1) {
      enqueueSnackbar('Please Enter Information Into Form', {
        variant: 'error',
      });
      setIsLoading(false);
    } else if (
      Object.keys(values).length >= 1 &&
      !values.firstName &&
      !values.lastName &&
      !values.companyName &&
      tabValue === 0
    ) {
      enqueueSnackbar(
        'Please Enter either a Person or Company Name for the Entity',
        { variant: 'error' },
      );
      setIsLoading(false);
    } else {
      let query: any;
      if (tabValue === 0) {
        let countryArr = undefined;
        if (values.country) {
          countryArr = [values.country?.toLowerCase()];
        }
        if (values.firstName || values.lastName) {
          query = {
            primary:
              `${values.firstName?.toLowerCase()} ${values.lastName?.toLowerCase()}`.replaceAll(
                'undefined',
                '',
              ),
            secondary: values.companyName?.toLowerCase(),
            country: countryArr,
            state: values.state?.toLowerCase(),
            postalCode: values.postalCode?.toLowerCase(),
            city: values.city?.toLowerCase(),
            fuzziness: fuzzyNum,
            pageNum: pageNumber,
          };
        } else {
          query = {
            primary: values.companyName?.toLowerCase(),
            country: countryArr,
            state: values.state?.toLowerCase(),
            postalCode: values.postalCode?.toLowerCase(),
            city: values.city?.toLowerCase(),
            pageNum: pageNumber,
            fuzziness: fuzzyNum,
          };
        }
      } else {
        query = {
          fuzziness: fuzzyNum,
          hsCodeSearch: values.harmonizedScheduleCode,
          commodity_name: values.commodityName?.toLowerCase(),
          pageNum: pageNumber,
        };
      }
      await setPDFQuery(query);

      const res = await DatahubAPI.biteScore(query);
      if (res?.success) {
        const entityTotal = [
          res.result[0].result?.body?.hits?.total?.value,
          res.result[1].result?.body?.hits?.total?.value,
          res.result[3].result?.body?.hits?.total?.value,
        ]
          .filter((e) => e !== undefined)
          .reduce((partialSum, a) => partialSum + a, 0);
        const watchlistPages = Math.ceil(
          res.result[0].result?.body?.hits?.total?.value / 50,
        );
        const biteListPages = Math.ceil(
          res.result[1].result?.body?.hits?.total?.value / 50,
        );
        const cyberPages = Math.ceil(
          res.result[3].result?.body?.hits?.total?.value / 50,
        );
        if (watchlistPages >= biteListPages && watchlistPages >= cyberPages) {
          setEntityPages(watchlistPages);
        } else if (
          biteListPages >= watchlistPages &&
          biteListPages >= cyberPages
        ) {
          setEntityPages(biteListPages);
        } else {
          setEntityPages(cyberPages);
        }

        if (
          entityTotal === 0 &&
          (res.result[2].result?.body?.hits?.total?.value === 0 ||
            !res.result[2].success)
        ) {
          enqueueSnackbar('No results Found for the submited values', {
            variant: 'info',
          });
          setIsLoading(false);
          setEntityScore(0);
          setCommodityScore(0);
          setEntityHits([]);
          setCommodityHits([]);
        } else {
          // Entity and Commodity Scores
          setEntityScore(entityTotal);
          setCommodityScore(
            res.result[2].result?.body?.hits?.total?.value
              ? res.result[2].result?.body?.hits?.total?.value
              : 0,
          );

          // Display Panel Info
          const entityHitArr: Hit[] = [];
          const commodityHitArr: Hit[] = [];

          await res.result[0].result?.body?.hits?.hits?.forEach((hit: any) => {
            const hitObj: Hit = {
              field: Object.values(hit.highlight)[0],
              module: 'BITE Watchlist',
              dataSet: hit._source['List Name'],
              name: hit._source['Name of Entity'],
              doc: hit._source,
            };
            entityHitArr.push(hitObj);
          });
          await res.result[1].result?.body?.hits?.hits?.forEach((hit: any) => {
            const hitObj: Hit = {
              field: Object.values(hit.highlight)[0],
              module: 'High Risk Entities',
              dataSet: hit._source['List Name'],
              name: hit._source['Name of Entity'],
              doc: hit._source,
            };
            entityHitArr.push(hitObj);
          });
          await res.result[2].result?.body?.hits?.hits?.forEach((hit: any) => {
            const hitObj: Hit = {
              field: Object.values(hit.highlight)[0],
              module: 'Trade Protection',
              dataSet: hit._source['List Name'],
              name: hit._source['Product Name'],
              doc: hit._source,
            };
            commodityHitArr.push(hitObj);
          });
          await res.result[3].result?.body?.hits?.hits?.forEach((hit: any) => {
            const hitObj: Hit = {
              field: Object.values(hit.highlight)[0],
              module: 'Cyber Protection',
              dataSet: hit._source['IP Address']
                ? 'Embargoed IP Addresses'
                : hit._source['List Name'],
              name: hit._source['Name of Entity']
                ? hit._source['Name of Entity']
                : hit._source['IP Address']
                ? hit._source['IP Address']
                : hit._source['CVE ID']
                ? hit._source['CVE ID']
                : hit._source['CVE ID']
                ? hit._source['CVE ID']
                : hit._source['Market Name'],
              doc: hit._source,
            };
            entityHitArr.push(hitObj);
          });
          setEntityHits(entityHitArr);
          setCommodityHits(commodityHitArr);
          setIsLoading(false);

          if (optsState.ticket) {
            const file: any = await searchReport(
              'bite-score-results',
              refForPdf,
              pdfQuery,
              headers,
              [...entityHitArr, ...commodityHitArr],
              false,
              'bite-score',
            );
            const base64Str = await toBase64(file);
            const new_val = {
              uploadedFile: {
                base64: base64Str,
                name: `bite-score-${formatted_dt}.pdf`,
              },
            };
            let query = {};
            if (tabValue === 0) {
              query = {
                docType: 'riskScore',
                status: 'draft',
                basics: {
                  date: formatted_dt,
                },
                ticketName: values.ticketName,
                entity: values,
                documents: [new_val],
              };
            } else {
              query = {
                docType: 'riskScore',
                status: 'draft',
                basics: {
                  date: formatted_dt,
                },
                ticketName: values.ticketName,
                commodities: [values],
                documents: [new_val],
              };
            }
            handleTicket(query);
          }
        }
      } else {
        const error_msg = 'Error finding score.';
        enqueueSnackbar(error_msg, { variant: 'error' });
        setIsLoading(false);
      }
    }
  };

  // BITE VAULT TICKET
  const handleTicket = async (values: any) => {
    const new_case = {
      groupId: cur_user.selected_team.id,
      ...values.basics,
      ...values,
    };
    const resp = await CasesAPI.createCase({ newCase: new_case });
    if (resp?.success) {
      enqueueSnackbar('Successfully created new case', { variant: 'success' });
    } else if (resp) {
      const error_msg =
        'Error saving new case. Uploaded file(s) may be too large.';
      enqueueSnackbar(error_msg, { variant: 'error' });
    }
  };

  const helpContent = (
    <ol className='module-header-tooltip-text'>
      <li>
        Select which category you would like to search: Entities or Commodities.
      </li>
      <br></br>
      <li>Fill out the required fields with your desired information.</li>
      <br></br>
      <li>Click the search button.</li>
      <br></br>
      <li>
        The app will start to sort through the database. Please note this may
        take a few moments.
      </li>
      <br></br>
      <li>
        The results will appear in a table underneath the initial search box.
        Please note you may need to scroll down to see all the results.
      </li>
    </ol>
  );

  return (
    <div>
      <Prompt
        when={Object.keys(pdfQuery).length >= 1}
        message={() =>
          'Are you sure you want to leave this page? Your results will be lost if you have not downloaded them.'
        }
      />
      <ModuleHeaderLayout title='BITE Search' helpContent={helpContent}>
        <div></div>
        <div className={!userHasBiteScore ? 'blur-div' : ''}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <StyledTabs value={tabValue} onChange={tabChange}>
                <StyledTab label='Entities' {...a11yProps(0)} />
                <StyledTab label='Commodities' {...a11yProps(1)} />
              </StyledTabs>
            </Grid>
            <Grid item xs={12} md={8}>
              <TabPanel value={tabValue} index={0} className=''>
                <EntityForm
                  handleSubmit={handleSubmit}
                  resetPage={resetPage}
                  optsState={optsState}
                  setOptsState={setOptsState}
                />
              </TabPanel>
              <TabPanel value={tabValue} index={1} className=''>
                <CommodityForm
                  handleSubmit={handleSubmit}
                  resetPage={resetPage}
                  optsState={optsState}
                  setOptsState={setOptsState}
                />
              </TabPanel>
            </Grid>
            <Grid item xs={12} sm={4} md={4} lg={4}>
              <div>
                <div ref={refForPdf}>
                  <ScoreIndicator score={entityScore + commodityScore} />
                </div>
                <div
                  className='bulk-pdf-download'
                  onClick={() => {
                    if (
                      (tabValue === 0 && Object.keys(entityHits).length) ||
                      (tabValue === 1 && Object.keys(commodityHits).length)
                    ) {
                      setFileNameModalOpen(true);
                    }
                  }}
                >
                  <p>Download as PDF</p>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='18'
                    height='18'
                    viewBox='0 0 18 18'
                    fill='none'
                  >
                    <path
                      d='M15 6.705C14.9922 6.6361 14.9771 6.56822 14.955 6.5025V6.435C14.9189 6.35788 14.8708 6.287 14.8125 6.225L10.3125 1.725C10.2505 1.66666 10.1796 1.61856 10.1025 1.5825H10.0275C9.95457 1.5435 9.8762 1.51569 9.795 1.5H5.25C4.65326 1.5 4.08097 1.73705 3.65901 2.15901C3.23705 2.58097 3 3.15326 3 3.75V14.25C3 14.8467 3.23705 15.419 3.65901 15.841C4.08097 16.2629 4.65326 16.5 5.25 16.5H12.75C13.3467 16.5 13.919 16.2629 14.341 15.841C14.7629 15.419 15 14.8467 15 14.25V6.75C15 6.75 15 6.75 15 6.705ZM10.5 4.0575L12.4425 6H11.25C11.0511 6 10.8603 5.92098 10.7197 5.78033C10.579 5.63968 10.5 5.44891 10.5 5.25V4.0575ZM13.5 14.25C13.5 14.4489 13.421 14.6397 13.2803 14.7803C13.1397 14.921 12.9489 15 12.75 15H5.25C5.05109 15 4.86032 14.921 4.71967 14.7803C4.57902 14.6397 4.5 14.4489 4.5 14.25V3.75C4.5 3.55109 4.57902 3.36032 4.71967 3.21967C4.86032 3.07902 5.05109 3 5.25 3H9V5.25C9 5.84674 9.23705 6.41903 9.65901 6.84099C10.081 7.26295 10.6533 7.5 11.25 7.5H13.5V14.25ZM9.9675 10.7175L9.75 10.9425V9C9.75 8.80109 9.67098 8.61032 9.53033 8.46967C9.38968 8.32902 9.19891 8.25 9 8.25C8.80109 8.25 8.61032 8.32902 8.46967 8.46967C8.32902 8.61032 8.25 8.80109 8.25 9V10.9425L8.0325 10.7175C7.89127 10.5763 7.69973 10.4969 7.5 10.4969C7.30027 10.4969 7.10873 10.5763 6.9675 10.7175C6.82627 10.8587 6.74693 11.0503 6.74693 11.25C6.74693 11.4497 6.82627 11.6413 6.9675 11.7825L8.4675 13.2825C8.53883 13.3508 8.62294 13.4043 8.715 13.44C8.80478 13.4797 8.90185 13.5002 9 13.5002C9.09815 13.5002 9.19522 13.4797 9.285 13.44C9.37706 13.4043 9.46117 13.3508 9.5325 13.2825L11.0325 11.7825C11.1737 11.6413 11.2531 11.4497 11.2531 11.25C11.2531 11.0503 11.1737 10.8587 11.0325 10.7175C10.8913 10.5763 10.6997 10.4969 10.5 10.4969C10.3003 10.4969 10.1087 10.5763 9.9675 10.7175Z'
                      fill='var(--alternative-text-color)'
                    />
                  </svg>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} style={{ marginBottom: '50px' }}>
              <Table
                pageNum={pageNum}
                entityPages={entityPages}
                handlePageChange={handlePageChange}
                hits={tabValue === 0 ? entityHits : commodityHits}
                totalHits={tabValue === 0 ? entityScore : commodityScore}
                loading={isLoading}
                tabValue={tabValue}
              />
            </Grid>
          </Grid>
        </div>
        <Modal
          isOpen={fileNameModalOpen}
          onRequestClose={handleFileNameClose}
          ariaHideApp={false}
        >
          <div className='bite-score-file-modal'>
            <div className='display-flex justify-between width-100'>
              <Typography variant='h5'>File Name:</Typography>
              <TicketButton
                onClick={handleFileNameClose}
                className='cursor-pointer'
              />
            </div>
            <div className='display-flex justify-end width-100'>
              <StyledInput
                value={fileName}
                onChange={handleFileNameChange}
                variant='outlined'
                className='margin-right-20px'
              />
              <NextButton
                variant='contained'
                color='primary'
                onClick={() => {
                  handleDownloadPDF();
                  handleFileNameClose();
                }}
              >
                Download
              </NextButton>
            </div>
          </div>
        </Modal>
      </ModuleHeaderLayout>
    </div>
  );
};

export default BiteScore;
